import { BidDecisionGroup, Customer, SiteVisitTypeEnum } from "@/graphql/__generated__/graphql";

/**
 * Prefills the Mobile Service form with realistic mock data for validation/testing.
 *
 * @param form - react-hook-form instance controlling the Mobile Service form
 * @param customer - current customer to derive sites from
 * @param biddingOperationalOrganizations - available operational org groups for selection
 * @param currentOrgId - current user's organization id
 */
export function prefillMobileServiceWithMockData(
  form: any,
  customer: Customer,
  biddingOperationalOrganizations: Partial<BidDecisionGroup>[],
  currentOrgId?: number
) {
  const { reset } = form;

  // Determine operational organization: prefer matching current org, else first available
  let selectedOperationalOrgId: number = 0;
  const matchingOperationalOrg = biddingOperationalOrganizations.find(
    (org) => (org.operationalOrganizationId ? Number(org.operationalOrganizationId) : undefined) === currentOrgId
  );

  if (matchingOperationalOrg?.operationalOrganizationId) {
    selectedOperationalOrgId = Number(matchingOperationalOrg.operationalOrganizationId);
  } else {
    const firstOrg = biddingOperationalOrganizations[0];
    selectedOperationalOrgId = firstOrg?.operationalOrganizationId ? Number(firstOrg.operationalOrganizationId) : 0;
  }

  // Select first site, if available
  const firstSite = customer?.sites?.[0];

  // Minimal valid site visit
  const mockSiteVisit = {
    duration: 60,
    margin: 6,
    type: SiteVisitTypeEnum.Opening,
    mondayDay: 1,
    mondayNight: 1,
    tuesdayDay: 1,
    tuesdayNight: 1,
    wednesdayDay: 1,
    wednesdayNight: 1,
    thursdayDay: 1,
    thursdayNight: 1,
    fridayDay: 1,
    fridayNight: 1,
    saturdayDay: 1,
    saturdayNight: 1,
    sundayDay: 1,
    sundayNight: 1,
    holidayDay: 1,
    holidayNight: 1,
    startDate: undefined,
    endDate: undefined,
  };

  reset({
    additional: false,
    name: "Mock Mobile Service",
    operationalOrganizationId: selectedOperationalOrgId,
    hourlyWage: 22.5,
    travelTime: 15,
    hoursBriefingPerEmployee: 4,
    info: "This is mock info for testing.",
    siteId: firstSite?.id || undefined,
    payGroup: "Group 1",
    nonTariffAllowance: 1.5,
    siteInput: undefined,
    siteVisits: [mockSiteVisit],
  });
}
